<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="page">
  <ground-header></ground-header>

  <!-- TODO(#1170): Extract the spinner into a component -->
  <div id="loading-spinner" class="loading-spinner" *ngIf="setupPhase === SetupPhase.LOADING">
    <div>
      <mat-spinner></mat-spinner>
      <p class="loading-label">Loading survey...</p>
    </div>
  </div>

  <div *ngIf="setupPhase !== SetupPhase.LOADING" class="container">
    <div class="card">
      <img
        *ngIf="setupPhase === SetupPhase.JOB_DETAILS"
        class="picture"
        src="/assets/img/add-job.svg"
        alt="Add a job"
      />
      <div class="create-survey-content">
        <div class="progress-bar-title">{{ progressBarTitle() }}</div>
        <mat-progress-bar
          mode="determinate"
          [value]="progressBarValue()"
        ></mat-progress-bar>
        <div [ngSwitch]="setupPhase">
          <ground-step-card
            *ngSwitchCase="SetupPhase.SURVEY_DETAILS"
            title="Start building your survey"
            description="Provide some basic info about your survey."
          >
            <survey-details
              #surveyDetails
              [title]="survey.title"
              [description]="survey.description"
              (onValidationChange)="onValidationChange($event)"
            ></survey-details>
          </ground-step-card>
          <job-details
            *ngSwitchCase="SetupPhase.JOB_DETAILS"
            #jobDetails
            [name]="jobName()"
            (onValidationChange)="onValidationChange($event)"
          ></job-details>
          <ground-step-card
            *ngSwitchCase="SetupPhase.DEFINE_LOIS"
            [jobName]="jobName()"
            title="Where should data be collected?"
            description="Data collectors will complete specified tasks for these sites."
          >
            <survey-loi #surveyLoi></survey-loi>
          </ground-step-card>
          <ground-step-card
            *ngSwitchCase="SetupPhase.DEFINE_TASKS"
            [jobName]="jobName()"
            title="What data should be collected?"
            description="Data collectors will be prompted to complete the tasks you define here for each data collection site."
          >
            <task-details
              #taskDetails
              (onValidationChange)="onValidationChange($event)"
            ></task-details>
          </ground-step-card>
          <ground-step-card
            *ngSwitchCase="SetupPhase.DEFINE_DATA_SHARING_TERMS"
            title="Data sharing agreement"
            description="Select the terms collectors need to agree to before collecting data."
          >
            <data-sharing-terms
              #dataSharingTerms
              [type]="survey.dataSharingTerms.type"
              [customText]="survey.dataSharingTerms.customText ?? ''"
              (onValidationChange)="onValidationChange($event)"
            ></data-sharing-terms>
          </ground-step-card>
          <ground-step-card
            *ngSwitchCase="SetupPhase.REVIEW"
            title="Review survey"
            description="Is your survey ready? Share it with collectors and other organizers."
          >
            <share-survey></share-survey>
          </ground-step-card>
        </div>
      </div>
    </div>
    <div class="button-section">
      <button
        id="back-button"
        class="button"
        (click)="back()"
        mat-button
        color="primary"
      >
        Back
      </button>
      <button
        id="continue-button"
        class="button continue-button"
        (click)="continue()"
        mat-flat-button
        color="primary"
        [disabled]="!canContinue"
      >
        {{ setupPhase === SetupPhase.REVIEW ? 'Go to survey' : 'Continue' }}
      </button>
    </div>
  </div>
</div>
